import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { PrismSelectInput, PrismTooltip } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import { BENI_PICKUP_DAYS } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

interface HotelBenchmarkInsightDropdownsDropdownPickupSignature {
  Args: {
    onChangePickup: unknown;
  };
}

export default class HotelBenchmarkInsightDropdownsDropdownPickup extends Component<HotelBenchmarkInsightDropdownsDropdownPickupSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { end, start } = this.args.selectedDateRange;

    const isPast =
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.hotelAndMarketService.isPast(dayjs(start)) &&
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.hotelAndMarketService.isPast(dayjs(end));

    return isPast;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get pickup() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const selectedPickup = this.args.pickup;
    const match = this.pickupOptions.find(
      (option) => option.id === selectedPickup,
    );
    return match;
  }

  @cached
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get pickupOptions() {
    const availableOptions = Object.values(BENI_PICKUP_DAYS).map((pickup) => {
      return {
        id: pickup,
        label: this.intl.t('benchmark_insight.pickup.count', { count: pickup }),
      };
    });

    return availableOptions;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipText() {
    if (this.isDisabled) {
      return this.intl.t('benchmark-insight.pickup.past-dates-disabled');
    }

    return null;
  }

  @action
  // @ts-expect-error: Incorrect type
  onPickupChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.onChangePickup(option.id);
  }

  <template>
    <PrismSelectInput
      @disabled={{this.isDisabled}}
      @onChange={{this.onPickupChange}}
      @options={{this.pickupOptions}}
      @value={{this.pickup}}
    />

    {{#if this.tooltipText}}
      <PrismTooltip @text={{this.tooltipText}} />
    {{/if}}
  </template>
}
